var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuesCard',{attrs:{"maxwidth":_vm.maxwidth,"ques":_vm.ques,"showIsAssign":true,"showInputCheck":true}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.ques.serial == null ? '' : _vm.ques.serial + '. ')+"文字題 ")]),_c('v-card-text',{staticClass:"text-start",attrs:{"slot":"content"},slot:"content"},[_vm._l((_vm.ques.cnName.split(/\r?\n/)),function(name,idx){return _c('div',{key:idx,staticClass:"blod quest_topic"},[_vm._v(_vm._s(name))])}),(_vm.ques.questHeadingPic)?_c('div',{staticClass:"text-center"},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.$store.state.server + _vm.ques.questHeadingPic}})]):_vm._e(),_c('v-textarea',{staticClass:"mt-2",attrs:{"disabled":_vm.$store.state.PhoneNum !== null && _vm.ques.isAssign && _vm.ques.inputCheck === '30',"outlined":"","rows":"1","auto-grow":"","label":"回答內容","rules":[
        // 檢查必填
        function (v) {
          var pass = !(_vm.ques.isRequired && !_vm.ques.value)
          return pass ? true : '此題為必填'
        },
        // 輸入檢查
        function (v) {
          switch (this$1.ques.inputCheck) {
            case '10':
              if (!v || v.length === 0) { return true }
              if (!/[0-9]{8}/.test(this$1.ques.value)) { return '請填寫正確的統一編號' }
              break
            case '20':
              if (!v || v.length === 0) { return true }
              if (!/.+@.+\..+/.test(this$1.ques.value.toLowerCase()))
                { return '請填寫正確的電子郵件' }
              break
            case '30':
              if (!v || v.length === 0) { return true }
              // 如果是 isAssign 就是手機，否則可能是市話
              if (this$1.ques.isAssign) {
                return /^09[0-9]{2}-?[0-9]{6}$/.test(this$1.ques.value)
                  ? true
                  : '請填寫正確的手機'
              }
              return /^([0-9]{2,3}-?)?[0-9]{7,8}$/.test(this$1.ques.value)
                ? true
                : '請填寫正確的電話'
              break
            default:
              return true
          }
        }
      ],"maxlength":_vm.ques.length},model:{value:(_vm.ques.value),callback:function ($$v) {_vm.$set(_vm.ques, "value", $$v)},expression:"ques.value"}})],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }